/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TxPlan/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function TxPlan({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/PaymentsEditAutopay/Content/SourceInvoice/TxPlan"
  
}) {
let constantData = 'Tx Plan: '
let editAutopayInfoReceivableTreatmentNameValueData = fromData.useDataValue({ viewPath,
context: 'edit_autopay_info',
path: 'receivable.treatment.name',
})
let aggregateData = fromAggregate.joinNoSpace(constantData, editAutopayInfoReceivableTreatmentNameValueData)
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="'Tx Plan: '"
 data="edit_autopay_info.receivable.treatment.name"
 aggregate="/Data/aggregate.js joinNoSpace"
 text={aggregateData}
/>
{children}
</React.Fragment>)
}